// Filter & Sort open and close
const toolOpenButton = document.querySelector("[data-tool-open]");
const toolCloseButton = document.querySelector("[data-tool-close]");
const toolSideBar = document.querySelector("[data-tool-sidebar]");

if (toolOpenButton) {
  toolOpenButton.addEventListener("click", () => {
    toolSideBar.dataset.toolSidebar = "open";
  })
}

if (toolCloseButton) {
  toolCloseButton.addEventListener("click", () => {
    toolSideBar.dataset.toolSidebar = "close";
  })
}

